import React, { useEffect, useState } from "react";
import { CalendarClock, Clock, Users, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import StatCard from "@/components/StatCard";
import AppointmentItem from "@/components/AppointmentItem";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

const ACTIONS = [
  { label: "Tamamlandı", status: "completed", testId: "tr-appt-complete" },
  { label: "Gelmedi", status: "no_show", testId: "tr-appt-noshow" },
];

export default function TrainerDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  const load = () => api.get("/dashboard/trainer").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const onStatus = async (id, status) => {
    try { await api.put(`/appointments/${id}/status`, { status }); toast.success("Güncellendi"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  if (!data) return <div className="space-y-4"><Skeleton className="h-24 rounded-2xl bg-[#13131C]" /><div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-32 rounded-2xl bg-[#13131C]" />)}</div></div>;

  const { real } = data;
  return (
    <div className="space-y-8" data-testid="trainer-dashboard">
      <PageHeader title={`Merhaba, ${user?.name?.split(" ")[0]} 👋`} subtitle="Bugünkü ders programın ve üye özetin" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testId="trainer-stat-today" icon={CalendarClock} label="Bugünkü Seans" value={real.today_sessions} accent />
        <StatCard testId="trainer-stat-upcoming" icon={Clock} label="Yaklaşan" value={real.upcoming} />
        <StatCard testId="trainer-stat-completed" icon={CheckCircle2} label="Tamamlanan" value={real.completed} />
        <StatCard testId="trainer-stat-members" icon={Users} label="Aktif Üyem" value={real.assigned_members} />
      </div>

      <section>
        <h4 className="font-display font-bold text-white text-lg mb-4">Bugünkü Program</h4>
        {real.schedule.length === 0 ? (
          <div className="text-center py-16 text-[#68687B] rounded-2xl border border-[#222230] bg-[#13131C]">Bugün için planlanmış dersin yok.</div>
        ) : (
          <div className="space-y-2">
            {real.schedule.map((a) => <AppointmentItem key={a.id} appt={a} actions={ACTIONS} onStatus={onStatus} />)}
          </div>
        )}
      </section>
    </div>
  );
}
